import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
const ElysSendDeceasedInformationSheetController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysSendDeceasedInformationSheetController.url(args, options),
    method: 'post',
})

ElysSendDeceasedInformationSheetController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
ElysSendDeceasedInformationSheetController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysSendDeceasedInformationSheetController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
ElysSendDeceasedInformationSheetController.post = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ElysSendDeceasedInformationSheetController.url(args, options),
    method: 'post',
})

export default ElysSendDeceasedInformationSheetController